import { useState, useEffect } from "react";

const useOrderData = (user) => {

  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const apiUrl = process.env.REACT_APP_API;
  useEffect(() => {

    const fetchOrderData = async () => {

      try {
        // Simulando uma requisição para obter os dados dos pedidos do usuário
        // Substitua esta parte pelo seu código de requisição real
        const response = await fetch(apiUrl + "pedido-editora-usuario-id/" + user);
        if (!response.ok) {
          throw new Error("Erro ao obter os dados dos pedidos.");
        }
        const data = await response.json();
        setOrders(data);
        setLoading(false);

      } catch (error) {
        setError(error.message);
        setLoading(false);
      }
    };

    fetchOrderData();
  }, []);

  return { orders, loading, error };
};

export default useOrderData;
